import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=131d6d79&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=131d6d79&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d6d79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131d6d79')) {
      api.createRecord('131d6d79', component.options)
    } else {
      api.reload('131d6d79', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=131d6d79&scoped=true", function () {
      api.rerender('131d6d79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/direct_investment_event/form/detail.vue"
export default component.exports